import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import './index.css';

// Layout
const DashboardLayout = lazy(() => import('./layouts/DashboardLayout').then(m => ({ default: m.DashboardLayout })));

// Pages
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const SignalsPage = lazy(() => import('./pages/SignalsPage'));
const PaperTrading = lazy(() => import('./pages/PaperTrading'));
const AlpacaTrader = lazy(() => import('./pages/AlpacaTrader'));
const AlpacaTraderOlMan = lazy(() => import('./pages/AlpacaTraderOlMan'));
const DayEngine = lazy(() => import('./pages/DayEngine'));
const CoinbaseStocks = lazy(() => import('./pages/CoinbaseStocks'));
const ReportsPage = lazy(() => import('./pages/ReportsPage'));

// Global error handler to catch unhandled errors
window.onerror = function(msg, url, line, col, error) {
  const errorDiv = document.createElement('div');
  errorDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:#F8F6F1;color:#1A1814;padding:40px;z-index:9999;overflow:auto';
  errorDiv.innerHTML = `
    <h1 style="color:#C43D3D">JavaScript Error</h1>
    <p>${msg}</p>
    <p>Source: ${url}:${line}:${col}</p>
    <pre style="background:#FFFFFF;padding:20px;border-radius:8px;overflow:auto;border:1px solid rgba(0,0,0,0.06)">${error?.stack || 'No stack trace'}</pre>
    <button onclick="location.reload()" style="margin-top:20px;padding:10px 20px;background:#D4A053;color:white;border:none;border-radius:4px;cursor:pointer">Reload</button>
  `;
  document.body.appendChild(errorDiv);
  return true;
};

// Promise rejection handler
window.onunhandledrejection = function(event) {
  console.error('Unhandled rejection:', event.reason);
};

const PageLoader = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="animate-pulse text-text-muted text-sm">Loading...</div>
  </div>
);

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<App />}>
              <Route element={<DashboardLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="signals" element={<SignalsPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="alpaca" element={<AlpacaTrader />} />
                <Route path="alpaca-ol-man" element={<AlpacaTraderOlMan />} />
                <Route path="day-engine" element={<DayEngine />} />
                <Route path="coinbase-stocks" element={<CoinbaseStocks />} />
              </Route>
              <Route path="paper" element={<PaperTrading />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </React.StrictMode>
  );
}
